import { useMediaQuery } from "@mantine/hooks";

import { MOBILE_MEDIA_QUERY } from "../constant/breakpoints";

export const useIsMobile = (): boolean => {
  // getInitialValueInEffect: false → read window.matchMedia synchronously on the
  // first render (in the browser) instead of deferring to an effect. Without it
  // the hook returns false (desktop) on first paint, so on a phone the desktop
  // tree mounts then swaps to mobile — a visible flash plus a double-mount that
  // double-fires the losing view's queries.
  return useMediaQuery(MOBILE_MEDIA_QUERY, false, { getInitialValueInEffect: false }) ?? false;
};
